import React from "react";
import fb from "../../Assets/Images/1 (1).svg";
import ig from "../../Assets/Images/1 (5).svg";
import li from "../../Assets/Images/1 (4).svg";
import yt from "../../Assets/Images/1 (3).svg";
import wu from "../../Assets/Images/1 (2).svg";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

function Banner({ isBanner, isSocial }) {
  const { t } = useTranslation();

  const containerStyle = {
    backgroundImage: `linear-gradient(270deg, rgba(0, 0, 0, 0.60) 9.81%, rgba(0, 0, 0, 0.00) 29.72%), url(${isBanner?.image_url})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  // الأيقونات الثابتة
  const icons = [fb, ig, li, yt, wu];

  // فلترة بيانات السوشيال حسب النوع fitout
  const fitoutSocials = isSocial?.data?.filter(item => item.type === "fitout") || [];

  return (
    <div
      style={containerStyle}
      className="relative w-full h-[200px] md:h-[200px] lg:h-[250px] xl:h-[350px] mt-[10rem] rounded-md"
      data-aos="fade-in"
      data-aos-easing="linear"
      data-aos-duration="1000"
      data-aos-delay="500"
    >
      {/* الـ Overlay */}
      <div className="absolute inset-0 bg-[#00000050] h-[200px] md:h-[200px] lg:h-[250px] xl:h-[350px] rounded-md pointer-events-none"></div>

      {/* المحتوى */}
      <div className="about-title absolute top-0 left-[1rem] lg:left-[5rem] lg:right-[3rem] right-[1rem] bottom-0 flex justify-between items-center">
        <h1
          className="text-[#fff] drop-shadow-text font-[700]"
          style={{ fontSize: "clamp(2rem, 3vw, 4rem)" }}
        >
          {t("Our Products")}
        </h1>

        {/* أيقونات الفلترة */}
        <div className="flex flex-col gap-4 items-center">
          {fitoutSocials.map((item, index) => (
            <span data-aos="fade-left" key={index}>
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={icons[index]} // أيقونة ثابتة حسب الترتيب
                  alt={item.type}
                  className="w-[1.5rem] h-[1.5rem]"
                />
              </a>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Banner;
